export default __webpack_public_path__ + "static/media/mining.14cdfe81.png";